var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickerPhotography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.3452 84.8355H67.9597C66.3885 84.8355 65.1133 83.5603 65.1133 81.9891V70.6036C65.1133 69.0324 66.3885 67.7572 67.9597 67.7572H79.3452C80.9164 67.7572 82.1916 69.0324 82.1916 70.6036V81.9891C82.1916 83.5603 80.9164 84.8355 79.3452 84.8355Z",
    fill: "#778E1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2343 67.7572C94.9799 67.7572 92.052 69.5656 90.5965 72.4784L87.2643 79.1427H66.0626C61.3547 79.1427 57.5234 82.974 57.5234 87.6819V133.224C57.5234 137.932 61.3547 141.763 66.0626 141.763H106.102L111.794 104.76L106.102 67.7572H98.2343Z",
    fill: "#005595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.141 79.1427H124.939L121.607 72.4784C120.151 69.5675 117.223 67.7572 113.969 67.7572H106.102V141.763H146.141C150.849 141.763 154.68 137.932 154.68 133.224V87.6819C154.68 82.974 150.849 79.1427 146.141 79.1427Z",
    fill: "#005595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.408 79.1427C98.8367 79.1427 97.5615 80.4179 97.5615 81.9891C97.5615 83.5603 98.8367 84.8355 100.408 84.8355H106.101L109.896 81.9891L106.101 79.1427H100.408Z",
    fill: "#FFECBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4844 116.146C80.4844 130.271 91.9762 141.763 106.102 141.763L111.795 116.146L106.102 90.5283C91.9762 90.5283 80.4844 102.02 80.4844 116.146Z",
    fill: "#C2DBE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.102 90.5283V141.763C120.227 141.763 131.719 130.271 131.719 116.146C131.719 102.02 120.227 90.5283 106.102 90.5283Z",
    fill: "#C2DBE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8701 116.146C91.8701 123.994 98.2555 130.378 106.102 130.378L109.897 116.146L106.102 101.914C98.2555 101.914 91.8701 108.297 91.8701 116.146Z",
    fill: "#FFECBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.102 130.378C113.95 130.378 120.333 123.994 120.333 116.146C120.333 108.297 113.95 101.914 106.102 101.914",
    fill: "#FFECBC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.641 81.9891C114.641 80.4179 113.366 79.1427 111.794 79.1427H106.102V84.8355H111.794C113.366 84.8355 114.641 83.5603 114.641 81.9891Z",
    fill: "#FFECBC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9089 93.3748C70.4809 93.3748 71.7553 92.1004 71.7553 90.5284C71.7553 88.9564 70.4809 87.682 68.9089 87.682C67.3369 87.682 66.0625 88.9564 66.0625 90.5284C66.0625 92.1004 67.3369 93.3748 68.9089 93.3748Z",
    fill: "#FFECBC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.622 83.1278C143.06 83.1278 141.775 81.8431 141.775 80.2814V76.1219C141.775 74.5602 143.06 73.2755 144.622 73.2755C146.183 73.2755 147.468 74.5602 147.468 76.1219V80.2814C147.468 81.8431 146.183 83.1278 144.622 83.1278Z",
    fill: "#FFCF00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.622 100.57C143.06 100.57 141.775 99.2856 141.775 97.7239V93.5644C141.775 92.0027 143.06 90.718 144.622 90.718C146.183 90.718 147.468 92.0027 147.468 93.5644V97.7239C147.468 99.2856 146.183 100.57 144.622 100.57Z",
    fill: "#FFCF00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.423 89.7693H151.263C149.692 89.7693 148.417 88.4941 148.417 86.9229C148.417 85.3517 149.692 84.0765 151.263 84.0765H155.423C156.994 84.0765 158.269 85.3517 158.269 86.9229C158.269 88.4941 156.994 89.7693 155.423 89.7693Z",
    fill: "#FFCF00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.981 89.7693H133.822C132.251 89.7693 130.976 88.4941 130.976 86.9229C130.976 85.3517 132.251 84.0765 133.822 84.0765H137.981C139.553 84.0765 140.828 85.3517 140.828 86.9229C140.828 88.4941 139.553 89.7693 137.981 89.7693Z",
    fill: "#FFCF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.101 138.418C118.402 138.418 128.373 128.446 128.373 116.146C128.373 103.845 118.402 93.8737 106.101 93.8737C93.8006 93.8737 83.8291 103.845 83.8291 116.146C83.8291 128.446 93.8006 138.418 106.101 138.418Z",
    stroke: "#005595",
    strokeWidth: 1.70783,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickerPhotography);
export default __webpack_public_path__ + "static/media/Sticker_photography.ecd613600b12a67c76b5402c0f97b94a.svg";
export { ForwardRef as ReactComponent };